/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../assets/css/GroupLoanReport.css"; // keep your custom CSS
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaRupeeSign } from "react-icons/fa";

const LoanReport = () => {
  const [loans, setLoans] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [groups,setGroups]=useState([]);
  const [centers,setCenters]=useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [filters, setFilters] = useState({
    schemeName: "",
    status: "",
    loanAppliedDate: "",
  });

    const { profile } = useSelector((state) => state.userProfile);
    const dispatch = useDispatch();
  
    useEffect(() => {
      dispatch(fetchUserProfile());
    }, [dispatch]);
  
  //  console.log("profile data is ",profile);
  
  const fetchLoanReport = async (page = currentPage) => {
      try {
        // const response = await fetch(
        //   `https://narrowitsolution.in/api/group-loan/emi-du?branchId=${localStorage.getItem("userId")}`
        // );
        // const data = await response.json();
        //  if (data.success && Array.isArray(data.loans)) {
        //    setLoans(data.loans);
        //  }

        const res = await axios.get(`https://narrowitsolution.in/api/group-loan/group/list`,
          {
             params: {
              superAdminId:profile.superAdminId,
              officerId: profile.id,
              groupId:selectedGroup.id,
              centerId:selectedCenter.id,
              page,
              limit: 20,
            }
        });
        console.log("response data",res);
        setLoans(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } catch (error) {
        console.error("Error fetching loan report:", error);
      } finally {
        setLoading(false);
      }
    };


  // useEffect(() => {
  //   console.log("aa gaya hu - useEffect called");

  //   fetchLoanReport()
  //     .then(() => console.log("fetchLoanReport success"))
  //     .catch(err => console.error("fetchLoanReport failed", err));

  // }, []);

 const fetchGroups = async () => {
    try {
      const res = await axios.get(
        `https://narrowitsolution.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter.id}`
      );

       console.log("groups data", res);
      setGroups(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        `https://narrowitsolution.in/api/group/centre?LoanofficerId=${profile.id}`
      );

       console.log("center data", res);
      setCenters(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

   useEffect(()=>{
      if(profile?.id)
      {
        fetchCenters();
      }
    },[profile?.id]);
  
    useEffect(()=>{
      if(selectedCenter?.id)
      {
        fetchGroups();
      }
    },[selectedCenter]);


  useEffect(()=>{
    fetchLoanReport();
  },[currentPage])

  const handleFilter = async(e) => {
    fetchLoanReport();
  }

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleViewEmi = (loan) => navigate(`/grouploan/grouploanreport/GroupLoanEmiDetails/${loan.id}`, { state: { loan } });
  const handleViewLoanCard = (loan) => navigate(`/grouploan/grouploanreport/GroupLoanEmiCard/${loan.id}`, { state: { loan } });
  const handleLoanApplicationForm = (loan) =>
    navigate(`/grouploan/grouploanreport/GroupLoanApplicationForm/${loan.id}`, { state: { loan } });

  const filteredLoans = loans.filter((loan) => {
    const schemeMatch =
      !filters.schemeName ||
      loan.schemeName?.toLowerCase().includes(filters.schemeName.toLowerCase());
    const statusMatch =
      !filters.status || loan.status?.toLowerCase() === filters.status.toLowerCase();
    const dateMatch =
      !filters.loanAppliedDate ||
      new Date(loan.loanAppliedDate).toLocaleDateString("en-CA") === filters.loanAppliedDate;
    return schemeMatch && statusMatch && dateMatch;
  });

  if (loading) {
    return (
      <div className="loadingWrapper">
        <div className="spinner"></div>
        <p>Loading loan report...</p>
      </div>
    );
  }

  // console.log("filtered loans ",filteredLoans);

  return (
    <div className="loanReportApp">
      <h2 className="reportTitle">📊 Group Loan Report</h2>
      
      <section className="filterCard">
          <div className="glr-filter">
              <label htmlFor="collectionLandmark">Select Collection Landmark</label>
              <select id="collectionLandmark" name="collectionLandmark" 
             
                onChange={(e) => {
                  const center = centers.find(
                    (c) => c.id === Number(e.target.value)
                  );
                  setSelectedCenter(center);
                }}>
                <option value="" >Select Landmark</option>
                {centers.map((c) => <option key={c.id} value={c.id}>{c.CenterName}</option>)}
              </select>
          </div>
          <div className="glr-filter">
              <label htmlFor="grouploan">Select Group Name</label>
              <select
                  id="grouploan"
                  name="grouploan"
                  value={selectedGroup ? selectedGroup.id : ""}
                  onChange={(e) => {
                    const group = groups.find(
                      (g) => g.id === Number(e.target.value)
                    );
                    setSelectedGroup(group);
                  }}
                >
                  <option value="">
                    Select Group Name
                  </option>

                  {groups.map((gn) => (
                    <option key={gn.id} value={gn.id}>
                      {gn.groupname}, {gn.groupcode}
                    </option>
                  ))}
              </select>
          </div>
          <button className="glr-submit-btn" onClick={handleFilter}>submit</button>
      </section>


      {/* 🔍 Filter Section */}
      <div className="filterCard">
        <input
          type="text"
          className="filterInput"
          placeholder="🔎 Filter by Scheme"
          value={filters.schemeName}
          onChange={(e) => handleFilterChange("schemeName", e.target.value)}
        />
        <select
          className="filterSelect"
          value={filters.status}
          onChange={(e) => handleFilterChange("status", e.target.value)}
        >
          <option value="">All Status</option>
          <option value="ACTIVE">ACTIVE</option>
          <option value="pending">pending</option>
          <option value="rejected">Rejected</option>
        </select>
        <input
          type="date"
          className="filterInput"
          value={filters.loanAppliedDate}
          onChange={(e) => handleFilterChange("loanAppliedDate", e.target.value)}
        />
      </div>

      

      {/* 💻 Desktop Table */}
      <div className="tableWrapper desktopOnly">
        <table className="loanDetailsTable">
          <thead>
            <tr>
              <th>Account No</th>
              <th>Loan Amount</th>
              <th>Customer name</th>
              <th>Group Leader Name</th>
              <th>Group</th>
              <th>Principal</th>
              <th>ROI (%)</th>
              <th>Tenure</th>
              <th>Frequency</th>
              <th>Applied Date</th>
              <th>Status</th>
              {/* <th>Member ID</th> */}
              {/* <th>Outstanding</th> */}
              <th>View EMI</th>
              <th>Loan Card</th>
              {/* <th>Loan Application</th> */}
            </tr>
          </thead>
          
          <tbody>
              {filteredLoans.length > 0 ? (
                  filteredLoans.map((item, index) => (
                    <tr key={item.id}>
                      <td>{item.loanAccountNumber}</td>
                      <td>{item.loanAmount}</td>
                      <td>{item.memberName}</td>
                      <td>{item.groupLeaderName}</td>
                      <td>{item.groupName}</td>
                      <td>{item.loanAmount}</td>
                      <td>{item.loanRoi}</td>
                      <td>{item.loanTenure}</td>
                      <td>{item.loanRecoveryFrequency}</td>
                      <td>{new Date(item.loanAppliedDate).toLocaleDateString("en-GB")}</td>
                      <td>{item.status}</td>
                      {/* <td>{item.memberId}</td> */}
                      {/* <td>{item.loanPayable}</td> */}
                      {/* const loanStatus = loan.status?.toLowerCase(); */}
                      <td>
                       {item.status.toLowerCase() === 'active' ? (
                          <button className="BranchLoanReport-btn-view-emi" onClick={() => handleViewEmi(item)}><FaRupeeSign/></button>
                        ) : <span className="BranchLoanReport-na">N/A</span>}  
                          {/* <button className="BranchLoanReport-btn-view-emi" onClick={() => handleViewEmi(item)}>View EMI</button> */}
                      </td>
                      <td>
                        {item.status.toLowerCase() === 'active' ? (
                          <button className="BranchLoanReport-btn-loan-card" onClick={() => handleViewLoanCard(item)}>Loan Card</button>
                        ) : <span className="BranchLoanReport-na">N/A</span>} 
                      </td>
                      {/* <td>
                        {['disbursed', 'approved', 'pending'].includes(item.status) ? (
                          <button className="BranchLoanReport-btn-loan-application" onClick={() => handleLoanApplicationForm(item)}>Loan Application</button>
                        ) : <span className="BranchLoanReport-na">N/A</span>} 
                      </td> */}
                      
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  </tr>
                )}
          </tbody>


        </table>
      </div>

      {/* 📱 Mobile Card Layout */}
      <div className="mobileOnly">
        {filteredLoans.length > 0 ? (
          filteredLoans.map((item,index) => (
            <div key={item.id} className="loanCard">
              <h3 className="loanCardTitle">{item.loanAccountNumber}</h3>
              <p><strong>Loan Amount: </strong>{item.loanAmount}</p>
              <p><strong>Scheme : </strong></p>
              <p><strong>Centre:</strong> {item.centerName}</p>
              <p><strong>Group:</strong> {item.groupName}</p>
              <p><strong>Principal:</strong> ₹{item.loanAmount}</p>
              <p><strong>ROI:</strong> {item.loanRoi}%</p>
              <p><strong>Tenure:</strong> {item.loanTenure} months</p>
              <p><strong>Frequency:</strong> {item.loanRecoveryFrequency}</p>
              <p><strong>Applied Date:</strong> {new Date(item.loanAppliedDate).toLocaleDateString()}</p>
              <p><strong>Status:</strong> <span className={`statusBadge ${item.status.toLowerCase()}`}>{item.status}</span></p>
              <p><strong>Member ID : </strong>{item.memberId}</p>
              <p><strong>Outstanding : </strong>{item.loanPayable}</p>
            </div>
          ))
        ) : (
          <p>No loans found.</p>
        )}
      </div>

        <div className="account-ledger-list-pagination-section">
            <div className="account-ledger-list-pagination-div">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
         </div>
    </div>
  );
};

export default LoanReport;